import * as React from 'react';
import './index.css';

interface IState {
}

interface Props {
  title: string;
  rightComponent?: any;
  leftComponent?: any;
}

export default class NavigationBar extends React.Component<Props, IState> {
  pop = () => {
    // @ts-ignore
    const WMRouter = Mach.requireModule('Router');
    WMRouter.navigateBack();
  }

  render() {
    const statusBarHeight = Mach.env.statusBarHeight;
    return (
      <view className="container">
        {/* 一定要加这一层 */}
        <view className="container-wrapper" style={{ height: Mach.env.navigationBarHeight + statusBarHeight }}>
          <view style={{ height: statusBarHeight }} />
          <view className="title-container-inner" style={{ height: Mach.env.navigationBarHeight }}>
            <view className="title-text-wrapper">
              <text className="title">{this.props.title}</text>
            </view>
            <view
              className="back-button-container"
              style={{ height: Mach.env.navigationBarHeight }}
              onClick={() => this.pop()}
            >
              <image
                src="https://p1.meituan.net/travelcube/71433e1087beecfcb1e49d5f4fe11042680.png"
                className="back-button"
                autoRTL
              />
            </view>
            <view className="left-wrapper">
              {this.props.leftComponent}
            </view>
            <view className="right-wrapper">
              {this.props.rightComponent}
            </view>
          </view>
        </view>
      </view>
    );
  }
}
